<template>
  <div style="height: 100%;width: 100%">
    <div ref="container" style="height: 100%"></div>
    <elastic-dialog
      :header="infoTitle"
      v-if="infoMessage"
      hideCancel=true
      applyBtnName="OK"
      @apply="()=>this.infoMessage=''">
      <slot><div v-html="infoMessage"></div></slot>
    </elastic-dialog>
  </div>
</template>


<script>
  import 'dhtmlx-gantt'
  import moment from 'moment'
  import {merge, mergeWith, isArray} from 'lodash'
  import ElasticDialog from '@/components/basic/elastic-dialog'

  export default {
    name: "vue-gantt",
    props: {
      tasks: {
        type: Object,
        default() {
          return {data: [], links: []}
        }
      },
      config: {
        type: Object,
        default: () => ({})
      },
      taskInfo: {
        type: Object,
        default: null
      },
      sortColumn: {
        type: String,
      },
      isAscending: {
        type: Boolean,
        default: true
      },
      taskColors: {
        type: Object,
        default: () => ({})
      },
      dataFormat: {
        type: String,
        default: "DD-MM-YYYY HH:mm:ss"
      }
    },
    data() {
      return {
        infoMessage: '',
        infoTitle: this.taskInfo ? this.taskInfo.title : ''
      }
    },
    watch: {
      tasks: {
        handler(newVal) {
          this.initTasks();
        },
        deep: true
      },
      config: {
        handler() {
          this.mergeConfig();
        }
      }
    },
    methods: {
      mergeConfig() {
        mergeWith(gantt.config, this.config, (objValue, srcValue) => {
          if (isArray(srcValue)) {
            return srcValue
          }
        })
      },
      initTasks() {
        let scrollVert = gantt.$scroll_ver.scrollTop;
        let scrollHor = gantt.$scroll_hor.scrollLeft;

        gantt.parse(this.tasks);
        if (this.sortColumn) {
          gantt.sort(this.sortColumn, !this.isAscending);
        }
        gantt.refreshData();
        gantt.scrollTo(scrollHor, scrollVert);
      },
      initColors() {
        if (!this.taskColors) return;
        for (let colorName in this.taskColors.palette) {
          if (!this.taskColors.palette.hasOwnProperty(colorName)) continue;
          const color = this.taskColors.palette[colorName];
          const sheet = document.createElement('style');
          sheet.type = "text/css";
          sheet.innerHTML = `.${colorName}{border: 2px solid ${color}; color:${color}; background: ${color};}`;
          document.head.appendChild(sheet);
        }
      }
    },
    mounted: function () {
      this.initColors();

      gantt.templates.date_grid = date => moment(date).format(this.dataFormat);

      gantt.templates.task_class = (start, end, task) => {
        if (!this.taskColors) return;
        let mappingFunction = (this.taskColors.colorMapping) ? this.taskColors.colorMapping : value => value;
        return mappingFunction(task[this.taskColors.colorParam]);
      };

      gantt.init(this.$refs.container);
      gantt.clearAll();
      this.mergeConfig();
      this.initTasks();

      gantt.attachEvent("onTaskClick", id => {
        this.$emit("onTaskClick", gantt.getTask(id));
        return true;
      });

      gantt.attachEvent("onTaskDblClick", id => {
        if (id == null || !this.taskInfo) return;
        this.infoMessage = gantt.getTask(id)[this.taskInfo.infoParam];
        return false;
      });
    },
    components: {
      ElasticDialog
    },
  }
</script>

<style>
  @import "~dhtmlx-gantt/codebase/dhtmlxgantt.css";
</style>
